// extracted by mini-css-extract-plugin
export var contrastLow = "_2a-1";
export var externalLink = "_2a-2";
export var externalLinkIcon = "_2a-3";
export var link = "_2a-0";
export var linkLabel = "_2a-4";